import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8378%3A20026
 *
 * @param {SvgIconProps} props - svg props
 */
export const DragIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M5 9.74976C5 9.33554 5.29381 8.99976 5.65625 8.99976H18.3438C18.7062 8.99976 19 9.33554 19 9.74976V10.2498C19 10.664 18.7062 10.9998 18.3438 10.9998H5.65625C5.29381 10.9998 5 10.664 5 10.2498V9.74976Z' fill={color}/>
            <path d='M18.3438 13H5.65625C5.29381 13 5 13.3358 5 13.75V14.25C5 14.6642 5.29381 15 5.65625 15H18.3438C18.7062 15 19 14.6642 19 14.25V13.75C19 13.3358 18.7062 13 18.3438 13Z' fill={color}/>
        </SvgIcon>
    )
}

export default DragIcon
